import { MillesimeSelect } from "@src/components/MillesimeSelect/MillesimeSelect";
import { NoEntityForMillesime } from "@src/components/NoEntityForMillesime/NoEntityForMillesime";
import { isString } from "lodash";
import { ReactNode } from "react";
import { MainPageTemplate } from "./MainPageTemplate";
import styles from "./MainContentPageTemplate.module.scss";
import { UserMenu } from "../UserMenu/UserMenu";

type MainContentPageTemplateProps = {
  children: ReactNode;
  title: ReactNode;
  contentSelection?: ReactNode;
  actionNavigation?: ReactNode;
  hasMillesimeNavigation?: boolean;
  noEntity?: boolean;
  millesime?: number;
};

export function MainContentPageTemplate({
  children,
  title,
  actionNavigation,
  contentSelection,
  hasMillesimeNavigation = false,
  noEntity,
  millesime,
}: MainContentPageTemplateProps) {
  return (
    <MainPageTemplate>
      <div>
        <div className={styles.header}>
          <div className={styles.headerUserMenu}>
            {hasMillesimeNavigation && (
              <div className={styles.contentSelection}>
                <MillesimeSelect />
              </div>
            )}
            <UserMenu />
          </div>
          <div className={styles.actionNavigation}>{actionNavigation}</div>
        </div>
        <div className={styles.subHeader}>
          {isString(title) && <h1>{title}</h1>}
          {!isString(title) && title}
          <div className={styles.contentSelection}>{contentSelection}</div>
        </div>
        {noEntity && millesime && (
          <NoEntityForMillesime millesime={millesime} entityName="société" />
        )}
        <div className={styles.content}>{children}</div>
      </div>
    </MainPageTemplate>
  );
}
